import createPalette from "@material-ui/core/styles/createPalette";

declare module "@material-ui/core/styles/createPalette" {
	interface PaletteOptions {
		border: PaletteColorOptions;
	}

	interface SimplePaletteColorOptions {
		neutral?: string;
	}
}

const Colours = createPalette({
	primary: {
		main: "#000000",
		neutral: "#707070",
		dark: "#FFFFFF",
		light: "#FFFFFF",
	},
	secondary: {
		main: "#F5F5F5",
		dark: "#232323",
	},
	border: {
		main: "#CCCCCC",
		dark: "#999999",
	},
	success: {
		main: "#028702",
		light: "#F2F9F2",
	},
	error: {
		main: "#E02020",
		light: "#FDF2F2",
	},
	warning: {
		main: "#DA6A00",
		light: "#FFF9F0",
	},
	info: {
		main: "#005EAB",
		light: "#F2F7FB",
	}
});

export default Colours;
